// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  AnalyticsCallOptions,
  getAnalytics,
  logEvent,
  setUserId,
} from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyALYkZqTpcKkZjwjYrWGgFR2_BDFM4OY9Q',
  authDomain: 'agrocraft-artisan.firebaseapp.com',
  projectId: 'agrocraft-artisan',
  storageBucket: 'agrocraft-artisan.appspot.com',
  messagingSenderId: '318779067825',
  appId: '1:318779067825:web:f54255142e7e332f6ec190',
  measurementId: 'G-57KB4R09TM',
};

// Initialize Firebase
const isProd =
  window.location.origin === 'https://ai.nurture.farm';
const app = isProd
  ? initializeApp(firebaseConfig)
  : undefined;
export const appGetAnalytics = isProd
  ? () => getAnalytics(app)
  : () => {};
const analytics = isProd ? appGetAnalytics() : null;

export const appLogEvent = (
  eventName: string,
  eventParams?:
    | {
        [key: string]: unknown;
      }
    | undefined,
  options?: AnalyticsCallOptions | undefined
) => {
  if (isProd && analytics) {
    logEvent(analytics, eventName, eventParams, options);
  }
};

export { CUSTOM_EVENTS } from './customEvents';

export const setGAUserId = (userId: string | undefined) => {
  if (isProd && analytics && userId) {
    setUserId(analytics, userId);
  }
};
